<template>
  <div>
    <div
      v-if="!fromAgence"
      class="columns is-margin-bottom-small is-padding-top-xsmall is-padding-left">
      <div class="column">
        <div
          class="title is-4"
          v-if="editaccessalert == false">
          <b>Création d'un mandat sur ce canal</b>
        </div>
      </div>
    </div>
    <div
      :class="fromAgence ? 'is-margin-top' : null"
      class="columns is-margin-bottom-small is-padding-left">
      <div class="column is-6 is-paddingless-top">
        <div class="columns">
          <div
            v-if="editaccessalert == false"
            class="field column">
            <r-label
              :is-required="false"
              :label="'Programmes'"
              :value="programsChoosen"></r-label>
            <div v-if="programsAccess">
              <multiselect
                v-model="programsChoosen"
                :options="programsAccess"
                :multiple="false"
                class="multiselect--option-ico"
                :searchable="true"
                value="pk"
                :placeholder="''"
                name="programs"
                data-vv-as="Programmes"
                :close-on-select="true"
                :show-labels="false"
                label="name"
                track-by="pk"
                @search-change="getPrograms">
                <span slot="noResult">Oups! Aucun programme trouvé.</span>
                <span
                  slot="placeholder"
                  class="multiselect__placeholder">Sélectionnez ou saisissez un programme</span>
                <span slot="noOptions">La liste est vide</span>
              </multiselect>
              <p
                v-if="errors.has('programs')"
                class="help is-danger">
                {{ errors.first('programs') }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div
      v-if="fromAgence"
      class="field column is-vcentered is-margin-bottom">
      <div class="columns is-6 is-padding-left is-vcentered">
        <input
          id="remuneration"
          type="checkbox"
          name="remuneration"
          v-model="access.use_remuneration"
          class="switch is-success is-rounded">
        <label
          class="has-text-weight-light"
          for="remuneration">PRÉCISER UN TAUX DE COMMMERCIALISATION</label>
        <div
          v-if="fromAgence && !access.use_remuneration && ((isAdmin && programsCurrent) || editaccessalert == true)"
          class="field is-margin-left">
          <a
            :style="'width: 100%'"
            class="button is-transform-none"
            @click="openQuickView">
            <span class="icon is-small"><i class="fal fa-tasks"></i></span>
            <span>{{ editaccessalert == true || (allotments && allotments.length) ? 'Définir' : 'Définir' }} allotement</span>
          </a>
        </div>
      </div>
    </div> -->
    <div class="columns is-multiline is-padding-left">
      <div
        v-if="!fromAgence"
        class="column is-12 is-5-widescreen is-4-fullhd">
        <div class="title is-5 has-text-weight-bold is-margin-bottom-xsmall">
          Date d'ouverture et de clôture
          <span class="is-margin-left-xsmall icon is-medium">&nbsp;</span><!-- Laisser cette ligne pr garantir un bon alignement -->
        </div>
        <div class="field">
          <date-picker
            :model="{start_date: access.start_date, end_date: access.end_date}"
            :is-range="true"
            :name="'date'"
            data-vv-as="Date d'ouverture et de clôture"
            :v-validate="'required'"
            :is-required="false"
            :style-version="2"
            :config="{mode: 'range'}"
            @input="Object.assign(access, $event)"></date-picker>
          <p
            v-if="errors.has('date')"
            class="help is-danger">
            {{ errors.first('date') }}
          </p>
        </div>
      </div>
      <div
        v-if="!fromAgence"
        :class="!fromAgence ? 'is-7-widescreen is-8-fullhd': null"
        class="column is-12">
        <div
          class="title is-5 has-text-weight-bold is-margin-bottom-xsmall">
          {{ fromAgence ? 'Taux de rémunération appliqué au programme' : 'Taux de rémunération appliqué au mandat' }}
          <span
            v-if="!fromAgence"
            class="is-margin-left-xsmall icon is-medium"
            v-helper.bottom.small="'TB0OoATNl7Az15AJdBqQ6'">
            <i class="fal fa-question-circle has-text-grey"></i>
          </span>
        </div>
        <div class="columns">
          <div
            :class="!fromAgence ? 'is-3-widescreen' : null"
            class="column is-4">
            <input
              class="vadCheckradiocase is-primary is-fullwidth"
              id="remProgramme"
              type="radio"
              name="remProgramme"
              :value="REMUNERATION_MODES.PROGRAM"
              v-model="remunerationMode">
            <label
              class="has-text-weight-light"
              for="remProgramme"
              style="text-transform: capitalize">programme</label>
          </div>
          <div
            :class="!fromAgence ? 'is-3-widescreen' : null"
            class="column is-4"
            v-if="remunerationMode !== REMUNERATION_MODES.CUSTOM">
            <input
              class="vadCheckradiocase is-primary is-fullwidth"
              id="remCustom"
              type="radio"
              name="remCustom"
              :value="REMUNERATION_MODES.CUSTOM"
              v-model="remunerationMode">
            <label
              class="has-text-weight-light"
              for="remCustom">Taux spécifique</label>
          </div>
          <div
            v-if="remunerationMode == REMUNERATION_MODES.CUSTOM"
            class="column is-4">
            <v-input
              :name="'remunerationInput'"
              :classes-input="'vadCheckradiocase is-active is-input is-fullwidth'"
              :has-incrementations="true"
              input-type="number"
              @input="val => updateRem(val)"
              :model="access.remuneration"
              :has-addons="true"
              :max="100"
              :step="1"
              :number="true"
              :errors-bag="errors"
              data-vv-value-path="val"
              ref="custominputParent"
              :reference="'custominput'"
              data-vv-as="remunerationInput">
              <p
                class="control"
                slot="addonRight">
                <a class="button is-grey is-square is-static">
                  <span class="icon"><i class="fas fa-percentage"></i></span>
                </a>
              </p>
            </v-input>
          </div>
          <!-- <div
            v-if="fromAgence && access.use_remuneration && ((isAdmin && programsCurrent) || editaccessalert == true)"
            class="field column is-8 is-padding-bottom is-margin-left">
            <a
              class="button is-transform-none is-full-width"
              @click="openQuickView">
              <span class="icon is-small"><i class="fal fa-tasks"></i></span>
              <span>{{ editaccessalert == true || (allotments && allotments.length) ? 'Définir' : 'Définir' }} allotement</span>
            </a>
          </div> -->
        </div>
      </div>
    </div>
    <div
      v-if="(allotments && allotments.length) || (editallotments && editallotments.length) || (newAllotments && newAllotments.length)"
      class="column is-paddingless-top is-7 is-6-fullhd is-padding-left is-padding-bottom">
      <p class="has-text-grey is-size-6 has-text-weight-medium is-margin-bottom-small">
        {{ fromAgence ? 'Allotement. Seul ces lots sont visibles par l\'agence' : 'Allotement. Seul ces lots sont visibles par la société' }}
        <span
          class="is-size-3 is-margin-left-xsmall icon is-small"
          v-helper.bottom.small="'oxc5JGhFjuJyTrkyayueb'">
          <i class="fal fa-question-circle fa-xs has-text-grey"></i>
        </span>
      </p>
      <div class="tags">
        <template v-if="!newAllotments && allotments">
          <span
            v-for="allotment in allotments"
            :key="allotment.pk"
            class="tag is-allotement is-margin-right-xsmall is-normal is-wAuto">
            {{ allotment.ref || allotment.lot.ref }}
          </span>
        </template>
        <template v-else-if="newAllotments && newAllotments.length">
          <span
            v-for="editallotment in newAllotments"
            :key="editallotment.pk"
            class="tag is-allotement is-margin-right-xsmall is-normal is-wAuto">
            {{ editallotment.ref || editallotment.lot.ref }}
          </span>
        </template>
      </div>
    </div>
    <div
      v-if="((isAdmin && programsCurrent) || editaccessalert == true)"
      class="column is-self-flex-start is-padding-bottom">
      <a
        class="button is-fullwidth is-transform-none"
        @click="openQuickView">
        <span class="icon is-small"><i class="fal fa-tasks"></i></span>
        <span>{{ editaccessalert == true || (allotments && allotments.length) ? 'Modifier' : 'Définir' }} allotement</span>
      </a>
    </div>
    <submit-sticky-buttons
      @submit="checkSubmit"
      :loading="submitLoading"
      button-id="accessForm"></submit-sticky-buttons>
  </div>
</template>

<script>
import { Quickview, Sort } from '@/mixins'
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
import { concat, differenceBy } from 'lodash'

const REMUNERATION_MODES = Object.freeze({
  PROGRAM: 'PROGRAM',
  CUSTOM: 'CUSTOM'
})

export default {
  name: 'MandatForm',
  mixins: [Quickview, Sort],
  props: {
    accessPk: {
      type: String
    },
    sourceAccess: {
      type: Object
    },
    editaccessalert: Boolean,
    editaccess: {
      type: Object
    },
    editallotments: null,
    fromAgence: Boolean,
    agenceData: {
      type: Object
    }
  },
  data () {
    return {
      submitLoading: false,
      newName: false,
      canal: null,
      accounts: [],
      loading: false,
      tab: 'MEMBRES',
      tabs: 'MANDATS_VUE',
      programsCurrent: null,
      programsChoosen: [],
      programsAccess: [],
      access: {},
      programLots: [],
      allotments: null,
      newAllotments: null,
      REMUNERATION_MODES,
      remunerationMode: null,
      program: {},
      allAccess: null
    }
  },
  computed: {
    ...mapState(['quickview', 'currentUser']),
    ...mapGetters(['isManager', 'isAdmin', 'isPromoteur', 'canAddUsers']),
    /**
      * pk of the canal
      * @return {string}
      */
    paramsPk () {
      return this.$route.params.id
    }
  },
  watch: {
    quickview ({ mode, params, results }) {
      if (results) {
        if (results && (mode === 'LOT_SELECTION' || mode === 'LOT_SELECTION_AMENAGEMENT')) {
          if (this.newAllotments) {
            this.$set(this, 'newAllotments', results.entities)
          } else {
            this.$set(this, 'allotments', results.entities)
          }
          this.$nextTick(() => {
            this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
          })
        }
      }
    },
    'programsChoosen' (v) {
      this.programsCurrent = v
      this.allotments = null
    },
    remunerationMode (v) {
      this.$nextTick(() => {
        if (this.remunerationMode === this.REMUNERATION_MODES.CUSTOM && this.$refs.custominputParent) {
          this.$refs.custominputParent.$refs.custominput.focus()
        }
      })
    }
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      if (this.editaccessalert === false) {
        this.access.start_date = moment().toISOString()
        this.access.end_date = moment().add(1, 'year').toISOString()
      }
      if (!this.fromAgence) {
        await this.getCanal()
      } else {
        await this.getAgence()
      }
      await this.getPrograms()
      if (this.editallotments) {
        this.newAllotments = this.editallotments
        this.access = this.editaccess
        this.remunerationMode = REMUNERATION_MODES.CUSTOM
      }
    //   this.$set(this, 'newName', this.canal.name)
    },
    /**
      * get canal
      */
    async getCanal () {
      this.loading = true
      try {
        let { data } = await this.$api.getOne(this.$resources.CHANNELS, this.paramsPk)
        this.canal = data
        this.loading = false
        this.accounts = this.canal.accounts_in_sales
      } catch (err) {
        console.log(err)
        this.loading = false
      }
    },
    async getAgence () {
      this.loading = true
      try {
        let { data } = await this.$api.getOne(this.$resources.AGENCE, this.paramsPk)
        this.agence = data
        this.loading = false
        this.accounts = this.agence.users
      } catch (err) {
        console.log(err)
        this.loading = false
      }
    },
    /**
      * get program
      */
    async getPrograms (query) {
      let params = {
        sort: 'name:asc',
        searchable_name: query,
        per_page: 200
      }
      let { data } = await this.$api.get(this.$resources.PROGRAM, params)
      let programAll = data.items
      try {
        let programAvailable
        if (this.fromAgence) {
          // let { data } = await this.$api.get(this.$resources.AGENCE_ACCESS, payload)
          let data = await this.getAllAgenceAccess()
          this.all_access = data
          let programUsed = []
          for (let mandat of this.all_access) {
            programUsed.push(mandat.program)
          }
          programAvailable = differenceBy(programAll, programUsed, x => x.pk)
        } else {
          let payload = {
            sales_channel: this.paramsPk
          }
          let { data } = await this.$api.get(this.$resources.MANDAT, payload)
          this.all_mandats = data.items
          let programUsed = []
          for (let mandat of this.all_mandats) {
            programUsed.push(mandat.program)
          }
          programAvailable = differenceBy(programAll, programUsed, x => x.pk)
        }

        this.program = programAvailable
        this.programsAccess = programAvailable
        this.loading = false
      } catch (err) {
        console.log(err)
        this.loading = false
      }
    },
    /**
      * get programlots
      */
    async getProgramLots (page = 1) {
      let params = null
      if (this.newAllotments) {
        params = { program: this.editaccess.program.pk, page: page }
      } else {
        params = { program: this.programsCurrent.pk, page: page }
      }
      let { data } = await this.$api.get(this.$resources.LOT, params)
      if (page > 1) {
        let totaLot = concat(data.items, this.programLots)
        this.programLots = totaLot
      } else {
        this.programLots = data.items
      }
      if (data.page < data.pages) {
        page++
        await this.getProgramLots(page)
      }
    },
    async getAllAgenceAccess (page = 1) {
      let query = {
        agence: this.paramsPk,
        page
      }
      let { data } = await this.$api.get(this.$resources.AGENCE_ACCESS, query)
      if (page > 1) {
        let totalAccess = concat(data.items, this.allAccess)
        this.allAccess = totalAccess
      } else {
        this.allAccess = data.items
      }
      if (data.page < data.pages) {
        page++
        await this.getAllAgenceAccess(page)
      }
      return this.allAccess
    },
    /**
      * Open quickview
      */
    async openQuickView () {
      await this.getProgramLots()
      if (this.program && this.program.is_amenagement) {
        this.openLotAmenagementSelectionQuickView(this.program, this.allotments, this.programLots)
      } else {
        if (this.newAllotments) {
          this.openLotSelectionQuickView(this.editaccess.program.pk, this.newAllotments, this.programLots)
        } else {
          this.openLotSelectionQuickView(this.programsCurrent, this.allotments, this.programLots)
        }
      }
    },
    /**
      * Update or Delete allotment
      */
    async updateAccessAllotment (access) {
      if (access.newAllotments) {
        let oldLots = []
        if (this.editallotments.length) {
          for (let lot of this.editallotments) {
            let value = {
              pk: lot.lot.pk,
              allotment_pk: lot.pk
            }
            oldLots.push(value)
          }
        }
        let toCreate = differenceBy(access.newAllotments, oldLots, x => (x.lot && x.lot.pk) || x.pk)
        let toDelete = differenceBy(oldLots, access.newAllotments, x => (x.lot && x.lot.pk) || x.pk)
        if (toCreate && toCreate.length) {
          const payload = {
            mandat: access.pk,
            lots: toCreate.map(x => x.pk)
          }
          try {
            await this.$api.axios.post(`allotments`, payload)
          } catch (err) {
            console.log(err)
            this.handleError(err)
          }
        }
        if (toDelete && toDelete.length) {
          for (let elem of toDelete) {
            try {
              await this.$api.axios.delete(`allotments/${elem.allotment_pk}`)
            } catch (err) {
              console.log(err)
              this.handleError(err)
            }
          }
        }
      }
    },
    checkSubmit () {
      if (this.fromAgence) {
        return this.submitAgence()
      } else {
        return this.submit()
      }
    },
    async submit () {
      if (!this.remunerationMode || (this.remunerationMode === REMUNERATION_MODES.CUSTOM && !this.access.remuneration)) {
        this.$toasted.global.danger('Veuillez saisir une rémunération correcte')
        return
      }
      if (this.access.remuneration <= 0) {
        this.$toasted.global.danger('le taux doit etre supérieur à 0%')
        return
      }
      if (this.access.remuneration > 100) {
        this.$toasted.global.danger('le taux doit etre inférieur à 100%')
        return
      }
      // if ((!('start_date' in this.access) || !this.access.start_date) || (!('end_date' in this.access) || !this.access.end_date)) {
      //   this.$toasted.global.danger('le taux doit etre inférieur à 100%')
      //   return
      // }
      let formIsValid = await this.$validator.validateAll()
      if (formIsValid && 'start_date' in this.access && 'end_date' in this.access) {
        this.submitLoading = true
        if (this.programsCurrent) {
          this.access.program = this.programsCurrent.pk
        }
        if (this.newAllotments) {
          this.access.newAllotments = this.newAllotments
          this.access.lots = this.newAllotments.map(x => (x.lot && x.lot.pk))
        } else if (this.allotments) {
          this.access.lots = this.allotments.map(x => x.pk)
        }
        if (this.remunerationMode === REMUNERATION_MODES.PROGRAM) {
          this.access.use_program_remuneration = true
          if (this.program) this.access.remuneration = this.program.remuneration
        }
        if (this.remunerationMode === REMUNERATION_MODES.CUSTOM) {
          this.access.use_program_remuneration = false
        }
        let pks = []
        this.canal.accounts_in_sales.forEach(x => {
          pks.push(x.pk)
        })
        this.access.accounts = pks
        this.access.sales_channel = this.canal.pk
        try {
          if (this.editaccess) {
            let accessPk = this.access.pk
            let { data } = await this.$api.axios.put(`/mandat-type/${accessPk}`, this.access)
            this.$toasted.global.success('Mandat mis à jour')
            await this.updateAccessAllotment(this.access)
            this.$emit('afterupdate', data)
            this.submitLoading = false
          } else {
            let { data } = await this.$api.axios.post('mandat-type', this.access)
            this.$emit('aftercreate', data)
            this.$toasted.global.success('Mandat créé')
            this.submitLoading = false
          }
        } catch (err) {
          this.submitLoading = false
          console.log(err)
          this.$toasted.global.danger('Erreur !')
        }
      }
    },
    async submitAgence () {
      let program
      if (this.editaccess) {
        program = this.editaccess.program
      } else {
        program = this.programsChoosen
      }
      if (!this.access.program && !program) {
        this.$toasted.global.danger('Veuillez choisir un programme')
        return
      }
      if (this.remunerationMode === REMUNERATION_MODES.PROGRAM) {
        this.access.remuneration = program.remuneration
      }
      if (this.remunerationMode === REMUNERATION_MODES.CUSTOM) {
        this.access.remuneration = this.access.remuneration
      }
      if (this.access.use_remuneration && (!this.remunerationMode || (this.remunerationMode === REMUNERATION_MODES.CUSTOM && !this.access.remuneration))) {
        this.$toasted.global.danger('Veuillez saisir une rémunération correcte')
        return
      }
      if (this.access.use_remuneration && this.access.remuneration <= 0) {
        this.$toasted.global.danger('le taux doit etre supérieur à 0%')
        return
      }
      if (this.access.use_remuneration && this.access.remuneration > 100) {
        this.$toasted.global.danger('le taux doit etre inférieur à 100%')
        return
      }

      let allotments
      if (this.newAllotments) {
        allotments = this.newAllotments
      } else {
        allotments = this.allotments
      }

      delete this.access.start_date
      delete this.access.end_date

      if (allotments) {
        this.access.lots = allotments.map(lot => lot.pk)
      }
      if (!this.access.use_remuneration) {
        this.access.remuneration = 0
      }
      this.access.program = program.pk
      this.access.agence = this.paramsPk
      if (this.editaccess) {
        let { data } = await this.$api.axios.patch(`/agence-access/${this.editaccess.pk}`, this.access)
        this.access.program = program
        this.$emit('afterupdate', data)
        this.$toasted.global.success('Lot(s) du programme mis à jour')
        this.submitLoading = false
      } else {
        let { data } = await this.$api.axios.post('agence-access', this.access)
        this.access.program = program
        this.$emit('aftercreate', data)
        this.$toasted.global.success('Programme ajouté')
        this.submitLoading = false
      }
    },
    updateRem (val) {
      this.access.remuneration = val
    }
  }
}
</script>
